/* CENTRO · Cajón de carrito RenovaInfinity (2026-09-09 · v2 2026-09-14 · v3 2026-09-15 · v4 2026-09-15b · v5 2026-09-15c · v6 2026-09-19 · v7 2026-09-19b · v8 2026-09-20)
   - Fuente de verdad: window.CentroCart (assets/centro-cart.js): estado inicial embebido por Liquid (cero peticiones al cargar),
     una sola lectura de /cart.js en vuelo, reintentos ante 429/5xx y eventos 'centro:cart:updated' / 'centro:cart:open' / 'centro:cart:error'.
     Si el motor no existe (asset ausente) el cajón trabaja solo con un respaldo mínimo.
   - Intercepta el icono del carrito (Shrine #cart-icon-bubble y el .cart[href=/cart] de las páginas custom) para abrir este cajón.
   - Líneas regalo: properties._centro_regalo == "1" → etiqueta REGALO, $0, sin cantidad ni quitar.
   - Envío gratis (regla real de Shopify): subtotal ≥ data-umbral ($1,247, descuento 1365579366540) o ≥ data-envio-min-pzas piezas
     (3, descuento 1361089396876 "ENVIO GRATIS EN TU PROMO ANTICAIDA": cuenta piezas de TODO el pedido) o ≥2 pzas de data-envio-2pzas.
   - Errores visibles: toast en el pie ("no pudimos actualizar…") + botón reintentar; ningún control se queda "cargando" (tope 12 s).
   - Timer de promo persistente en sessionStorage (10 min); al llegar a 0 se reinicia sin tocar el carrito.
   - 2026-09-14: campo Colonia RETIRADO (Héctor: era para el checkout y no se puede).
   - 2026-09-15 (v3): hitos en la barra de envío. 🎁 "1 producto gratis" al 50% SOLO si el carrito lleva una promo multiunidad
     (tabla PROMOS: 2+ pzas de un producto con promo, o línea regalo _centro_regalo, o descuento de promo ya aplicado en la línea);
     se desbloquea al alcanzar la cantidad mínima / tener el regalo. 🏆 "Envío gratis" SIEMPRE al final (reglas reales de envío).
     Al desbloquearse un hito se dispara la animación (clase is-pop) una sola vez por cambio de estado.
   - 2026-09-15b (v4): cada línea va en .ccd__swipe > .ccd__mov > (.ccd__line + button.ccd__del). Deslizar a la IZQUIERDA (pointer events,
     umbral 30 px, seguimiento del dedo, snap) descubre ELIMINAR a la derecha; tocar fuera / deslizar otra / deslizar de vuelta cierra (una a la vez).
     Si el gesto es más vertical que horizontal no se intercepta (touch-action: pan-y). ELIMINAR = change(key, 0) con colapso animado.
     Pista: nudge de 24 px en la primera línea la primera vez que se abre el cajón en la sesión (sessionStorage). v5 (2026-09-15c): sin texto de pista.
   - 2026-09-19 (v6): envío gratis de 2 anticanas por CÓDIGO (ENVIO2ANTICANAS, data-envio-2pzas-codigo). Shopify no puede condicionar un envío
     gratis por producto (el automático por subtotal se lo daba a crema+jabón), así que el botón PAGAR y el formulario de /cart van a
     /discount/CODIGO?redirect=/checkout SOLO si el carrito lleva ≥2 pzas (sin regalos) de un producto de data-envio-2pzas; si no, /checkout normal.
   - 2026-09-19b (v7): envío gratis POR PRODUCTO. data-envio-2pzas-codigos = mapa product_id:CODIGO (anticanas → ENVIO2ANTICANAS,
     aceite → ENVIO2ACEITES). El automático por subtotal ($1,247) se apagó, así que data-umbral=0 y la barra habla de PIEZAS, no de monto.
     El hito de 2 pzas cuenta por producto (1 anticanas + 1 aceite NO desbloquea).
   - 2026-09-20 (v8): el código de envío gratis se pega AL CARRITO (Cart API: POST /cart/update.js {discount}) en cada render, no solo al href del
     botón PAGAR: 8/8 pedidos de 2 anticanas del 19-20 sep llegaron al checkout por otra ruta y pagaron $100 de envío. Con el código en el carrito
     viaja por cualquier ruta (cajón, /cart Shrine, formulario del producto, pago rápido). Se quita solo si el carrito deja de calificar.
   API pública: window.CentroCartDrawer = { open, close, refresh, render, add, change, toast } */
(function () {
  'use strict';
  if (window.CentroCartDrawer) return;

  var root = document.getElementById('centro-cd');
  if (!root) return;

  var UMBRAL = parseInt(root.dataset.umbral || '124700', 10);            // centavos: $1,247
  var ENVIO_MIN_PZAS = parseInt(root.dataset.envioMinPzas || '0', 10);   // 3 piezas de lo que sea (si el descuento sigue activo), 0 = apagado
  var ENVIO_2PZAS = (root.getAttribute('data-envio-2pzas') || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);   // productos con envío gratis desde 2 pzas
  var CODIGO_2PZAS = (root.getAttribute('data-envio-2pzas-codigo') || '').trim();   // (v6) código único de respaldo; v7 usa el mapa de abajo
  var CODIGOS_2PZAS = {};   // v7 2026-09-19b: product_id → código de envío gratis (cada producto con el suyo)
  (root.getAttribute('data-envio-2pzas-codigos') || '').split(',').forEach(function (s) { var p = s.split(':'); if (p.length === 2 && parseInt(p[0], 10)) CODIGOS_2PZAS[parseInt(p[0], 10)] = p[1].trim(); });
  var HAY_UMBRAL = UMBRAL > 0;   // v7: 0 = ya no existe envío gratis por monto (automático 1365579366540 apagado)
  var TIMER_MIN = parseInt(root.dataset.timerMin || '10', 10);
  var TIMER_KEY = 'centro_promo_fin';
  var TOPE_BUSY_MS = 12000;

  // ---------- catálogo de sugeridos (id de producto → handle, nombre corto, categoría) ----------
  var CAT = {
    barba:    [8210115231884, 8202569056396, 8444452995212, 8207105818764],
    capilar:  [7946278273164, 8017735614604, 8202560929932, 8390881312908],
    rostro:   [7946252746892, 7946262872204, 7946271785100, 8444216115340],
    corporal: [8233818226828, 8390881312908, 7946271785100, 8444216115340]
  };
  var PROD = {
    8444452995212: { h: 'lapiz-y-cepillo-para-barba-color-negro', n: 'Lápiz rellenador de barba + cepillo', c: 'barba' },
    8202569056396: { h: 'aceite-engrosamiento-barba-bergamota-romero-eucalipto-50ml', n: 'Aceite engrosamiento de barba 50 ml', c: 'barba' },
    8210115231884: { h: 'balsamo-crecimiento-barba-ultrapotente-minoxidil-20-biotina-bergamota-celulas-madres-ingredientes-premium-100ml', n: 'Bálsamo crecimiento de barba · Minoxidil 20%', c: 'barba' },
    8207105818764: { h: 'shampoo-crecimiento-de-barba-minoxidil-15-bergamota-biotina-250ml', n: 'Shampoo mantenimiento de barba', c: 'barba' },
    10201820102796: { h: 'kit-de-barbones', n: 'Kit de Barbones', c: 'barba', noSug: true },
    10210918367372: { h: 'protocolo-rostro-masculino-3-0', n: 'Protocolo Rostro Masculino 3.0', c: 'rostro', noSug: true },
    8202560929932: { h: 'shampoo-anticaspa-climbazol-vitamina-b5-lecitina-250ml', n: 'Shampoo anticaspa · Climbazol + B5', c: 'capilar' },
    8017735614604: { h: 'shampoo-anticanas-de-organo-nogal-romero-250ml', n: 'Shampoo anticanas orgánico de romero', c: 'capilar' },
    7946278273164: { h: 'shampoo-de-biotina-con-minoxidil-y-bergamota-250ml', n: 'Shampoo anticaída · Minoxidil 15% + Biotina', c: 'capilar' },
    8390881312908: { h: 'exfoliante-premium-de-silicona-suave-e-higienico-cabello-y-cuerpo', n: 'Exfoliante premium de silicona · cabello y cuerpo', c: 'capilar' },
    7946252746892: { h: 'serum-acido-hialuronico', n: 'Sérum antiedad · Ácido hialurónico + Vit C', c: 'rostro' },
    7946262872204: { h: 'crema-facial-de-baba-de-caracol-y-de-colageno-125ml', n: 'Crema quita manchas · Baba de caracol', c: 'rostro' },
    7946271785100: { h: 'jabon-shampoo-facial-de-te-verde-vitamina-e-125ml', n: 'Jabón facial de té verde + Vitamina E', c: 'rostro' },
    8444216115340: { h: 'exfoliante-de-barba-de-silicona-suave-e-higienico', n: 'Exfoliante facial de silicona', c: 'rostro' },
    8233818226828: { h: 'jabon-corporal-masculino-feromonas-250ml', n: 'Jabón corporal masculino · Feromonas', c: 'corporal' }
  };
  var DEFAULT_SUG = [7946278273164, 8210115231884, 8017735614604, 8233818226828]; // carrito vacío o productos desconocidos
  // promos multiunidad vigentes (2026-09-15): producto → niveles (min piezas → etiqueta del logro). Solo etiquetas; precios/descuentos los aplica Shopify.
  var PROMOS = {
    7946278273164: [{ min: 3, txt: '3x2 $1,197 + envío gratis' }, { min: 5, txt: '2 productos gratis' }], // anticaída 1×$599 · 3x2 $1,197 · 5x3 $1,597 (sin promo de 2 pzas desde 2026-09-21 00:30)
    8210115231884: [{ min: 3, txt: '1 producto gratis' }, { min: 5, txt: '2 productos gratis' }],   // bálsamo barba 3 y 5 pzas
    8202569056396: [{ min: 2, txt: 'Promo 2 pzas' }, { min: 3, txt: '1 producto gratis' }],           // aceite: 2 pzas $1,247 · 3 = paga 2 lleva 3
    8233818226828: [{ min: 3, txt: '1 producto gratis' }, { min: 5, txt: '2 productos gratis' }],   // jabón 3x2 / 5x3 + exfoliante regalo
    8202560929932: [{ min: 2, txt: '1 producto gratis' }, { min: 3, txt: '2 productos gratis' }],   // anticaspa 2 y 3 pzas + anticaída regalo
    8017735614604: [{ min: 2, txt: 'Promo 2 pzas' }]                                                 // anticanas 2 pzas $1,298
  };
  var MAX_SUG = 4;

  // ---------- utilidades ----------
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  function mx(cents) {
    var n = Math.round(cents) / 100, ent = Math.floor(Math.abs(n)), dec = Math.round((Math.abs(n) - ent) * 100);
    var s = String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (dec) s += '.' + (dec < 10 ? '0' : '') + dec;
    return (n < 0 ? '-' : '') + '$' + s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    url = String(url).replace(/^\/\//, 'https://');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function esRegalo(item) {
    var p = item.properties || {};
    return String(p._centro_regalo || '') === '1';
  }
  function nombreCorto(item) {
    var m = PROD[item.product_id];
    if (m) return m.n;
    var t = item.product_title || '';
    t = t.split(' | ')[0].split(' - ')[0];
    if (t === t.toUpperCase()) t = t.charAt(0) + t.slice(1).toLowerCase();
    return t.length > 60 ? t.slice(0, 57) + '…' : t;
  }
  function catDe(item) {
    var m = PROD[item.product_id];
    if (m) return m.c;
    var h = (item.handle || '') + ' ' + (item.product_title || '').toLowerCase();
    if (/barba|barbones/.test(h)) return 'barba';
    if (/facial|rostro|serum|sérum|crema|caracol/.test(h)) return 'rostro';
    if (/corporal/.test(h)) return 'corporal';
    if (/shampoo|cabello|caida|caída|caspa|canas|exfoliante/.test(h)) return 'capilar';
    return null;
  }
  function imagenDe(it) {
    if (it.featured_image && it.featured_image.url) return it.featured_image.url;
    if (typeof it.image === 'string') return it.image;   // {{ cart | json }} de Liquid trae 'image' como cadena
    return '';
  }
  function CC() { return window.CentroCart && !window.CentroCart._fallback ? window.CentroCart : null; }

  // ---------- estado ----------
  var cart = null, cache = {}, abierto = false, ultimoFoco = null, timerId = null;
  var api = {};

  // ---------- fetch (respaldo si el motor no existe; con el motor se usa su req con reintentos) ----------
  function j(url, body) {
    if (window.CentroCart && window.CentroCart.req) return window.CentroCart.req(url, body);
    var opts = { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' };
    if (body !== undefined) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) { return r.text().then(function (t) { var d = null; try { d = JSON.parse(t); } catch (e) {} if (!r.ok || !d) { var err = new Error((d && d.description) || ('HTTP ' + r.status)); err.status = r.status; throw err; } return d; }); });
  }
  function producto(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = j('/products/' + handle + '.js').catch(function () { delete cache[handle]; return null; });
    return cache[handle];
  }
  function refresh() {
    var m = CC();
    if (m) return m.refresh();                                   // emite centro:cart:updated → render
    return j('/cart.js').then(function (c) { render(c); return c; });
  }
  function busy(el, on) {
    if (!el) return;
    if (on) { el.classList.add('is-busy'); clearTimeout(el.__busyT); el.__busyT = setTimeout(function () { el.classList.remove('is-busy'); }, TOPE_BUSY_MS); }
    else { clearTimeout(el.__busyT); el.classList.remove('is-busy'); }
  }
  function limpiarBusy() { $$('.is-busy').forEach(function (el) { busy(el, false); }); }
  function change(key, qty, el) {
    busy(el, true);
    var m = CC();
    var p = m ? m.change(key, qty) : j('/cart/change.js', { id: key, quantity: qty }).then(function (c) { render(c); emitir(c); return c; });
    return p.then(function (c) { busy(el, false); return c; }, function (e) { busy(el, false); if (!m) toast(mensaje(e)); });
  }
  function add(variantId, qty, el) {
    busy(el, true);
    var m = CC();
    var p = m ? m.add([{ id: variantId, quantity: qty || 1 }], { open: true, fallback: false })
              : j('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] }).then(function () { return j('/cart.js'); }).then(function (c) { render(c); emitir(c); open(true); return c; });
    return p.then(function (c) { busy(el, false); return c; }, function (e) { busy(el, false); if (!m) toast(mensaje(e)); });
  }
  function mensaje(e) { return (window.CentroCart && window.CentroCart.mensajeDe) ? window.CentroCart.mensajeDe(e) : ((e && e.message) || 'No pudimos actualizar tu carrito. Intenta de nuevo.'); }
  var emitiendo = false;
  function emitir(c) {
    emitiendo = true;
    try { document.dispatchEvent(new CustomEvent('centro:cart:updated', { detail: c, bubbles: false })); } finally { emitiendo = false; }
  }

  // ---------- envío gratis: la regla real del checkout ----------
  function envioEstado(c) {
    var sub = c.total_price, pzas = 0, por2 = 0;
    var por2Prod = {};
    c.items.forEach(function (it) { pzas += it.quantity; if (ENVIO_2PZAS.indexOf(it.product_id) > -1 && !esRegalo(it)) { por2Prod[it.product_id] = (por2Prod[it.product_id] || 0) + it.quantity; if (por2Prod[it.product_id] > por2) por2 = por2Prod[it.product_id]; } });
    if (HAY_UMBRAL && sub >= UMBRAL) return { ok: true, motivo: 'monto' };
    if (ENVIO_MIN_PZAS && pzas >= ENVIO_MIN_PZAS) return { ok: true, motivo: 'pzas' };
    if (por2 >= 2) return { ok: true, motivo: '2pzas' };
    return { ok: false, faltan: HAY_UMBRAL ? UMBRAL - sub : 0, pzasFaltan: ENVIO_MIN_PZAS ? ENVIO_MIN_PZAS - pzas : 0, por2Faltan: 2 - por2,
             pct: Math.max(4, Math.round(HAY_UMBRAL ? sub / UMBRAL * 100 : pzas / (ENVIO_MIN_PZAS || 3) * 100)) };
  }

  // ---------- URL de pago: aplica el código de envío gratis solo con ≥2 pzas de los productos de data-envio-2pzas ----------
  function codigoPara(c) {   // v8: código de envío gratis que le toca al carrito ('' si ninguno)
    if (!c || !c.items) return '';
    var porProd = {}, codigo = '';
    c.items.forEach(function (it) { if (!esRegalo(it)) porProd[it.product_id] = (porProd[it.product_id] || 0) + it.quantity; });
    Object.keys(CODIGOS_2PZAS).forEach(function (pid) { if (!codigo && porProd[pid] >= 2) codigo = CODIGOS_2PZAS[pid]; });
    if (!codigo && CODIGO_2PZAS && !Object.keys(CODIGOS_2PZAS).length) { var por2 = 0; ENVIO_2PZAS.forEach(function (pid) { por2 += porProd[pid] || 0; }); if (por2 >= 2) codigo = CODIGO_2PZAS; }
    return codigo;
  }
  function urlPago(c) {
    var codigo = codigoPara(c);
    return codigo ? '/discount/' + encodeURIComponent(codigo) + '?redirect=%2Fcheckout' : '/checkout';
  }
  // ---------- v8 2026-09-20: el código va EN EL CARRITO (Cart API), así llega al checkout por cualquier ruta ----------
  var MIS_CODIGOS = Object.keys(CODIGOS_2PZAS).map(function (k) { return CODIGOS_2PZAS[k]; }).concat(CODIGO_2PZAS ? [CODIGO_2PZAS] : []);
  var syncEnVuelo = false, syncFirma = '', syncAplicado = '';
  try { syncAplicado = localStorage.getItem('centro_envio_codigo') || ''; } catch (e) {}
  function sincronizarCodigo(c) {
    if (!c || !c.items || syncEnVuelo || !MIS_CODIGOS.length) return;
    var quiere = codigoPara(c), lista = c.discount_codes;   // change.js no trae discount_codes → se usa lo último aplicado
    var conocidos = Array.isArray(lista) ? lista.map(function (d) { return d.code; }) : null;
    var ajenos = conocidos ? conocidos.filter(function (x) { return MIS_CODIGOS.indexOf(x) < 0; }) : [];
    var mios = conocidos ? conocidos.filter(function (x) { return MIS_CODIGOS.indexOf(x) > -1; }) : (syncAplicado ? [syncAplicado] : []);
    if (quiere ? (mios.length === 1 && mios[0] === quiere) : !mios.length) { if (conocidos) syncAplicado = quiere; return; }
    if (!quiere && !c.items.length) return;   // carrito vacío: Shopify ya lo limpia
    var nuevo = ajenos.concat(quiere ? [quiere] : []).join(',');
    var firma = nuevo + '|' + c.item_count + '|' + c.total_price;
    if (firma === syncFirma) return;   // ya se intentó exactamente esto: no insistir (evita bucles si Shopify lo rechaza)
    syncFirma = firma; syncEnVuelo = true;
    j('/cart/update.js', { discount: nuevo }).then(function (c2) {
      syncEnVuelo = false; syncAplicado = quiere;
      try { localStorage.setItem('centro_envio_codigo', quiere); } catch (e) {}
      if (c2 && c2.items) { cart = c2; emitir(c2); }
    }, function () { syncEnVuelo = false; });
  }

  // ---------- promo multiunidad: ¿hay hito de regalo y está desbloqueado? ----------
  function promoEstado(c) {
    var porProd = {}, regalo = false, conDesc = {}, mejor = null;
    c.items.forEach(function (it) {
      if (esRegalo(it)) { regalo = true; return; }
      if (!PROMOS[it.product_id]) return;
      porProd[it.product_id] = (porProd[it.product_id] || 0) + it.quantity;
      if ((it.line_level_discount_allocations || []).length) conDesc[it.product_id] = true;
    });
    Object.keys(porProd).forEach(function (pid) {
      var q = porProd[pid], alc = null, sig = null;
      PROMOS[pid].forEach(function (n) { if (q >= n.min) alc = n; else if (!sig) sig = n; });
      var ok = !!alc || !!conDesc[pid];
      var cand = { ok: ok, txt: alc ? alc.txt : (sig ? sig.txt : PROMOS[pid][0].txt), faltan: ok || !sig ? 0 : sig.min - q, qty: q, visible: ok || q >= 2 };
      if (!mejor || (cand.ok && !mejor.ok) || (cand.ok === mejor.ok && cand.faltan < mejor.faltan)) mejor = cand;
    });
    if (regalo) { if (!mejor) mejor = { txt: '1 producto gratis', qty: 0 }; mejor.ok = true; mejor.faltan = 0; mejor.visible = true; }
    return mejor && mejor.visible ? mejor : null;
  }
  var hitoPrev = { promo: null, envio: null };
  function pintarHito(tipo, visible, ok, txt) {
    var h = $('[data-ccd-hito="' + tipo + '"]');
    if (!h) return;
    h.hidden = !visible;
    if (txt) { var t = $('.ccd__hito-txt', h); if (t) t.textContent = txt; }
    var estaba = hitoPrev[tipo];
    h.classList.toggle('is-on', !!ok);
    if (ok && visible && estaba === false) { h.classList.remove('is-pop'); void h.offsetWidth; h.classList.add('is-pop'); setTimeout(function () { h.classList.remove('is-pop'); }, 1300); }
    if (!ok) h.classList.remove('is-pop');
    hitoPrev[tipo] = visible ? !!ok : null;
  }
  function celebrar() {   // al abrir el cajón: replay del pop en los logros ya alcanzados
    $$('.ccd__hito.is-on').forEach(function (h, i) { setTimeout(function () { h.classList.remove('is-pop'); void h.offsetWidth; h.classList.add('is-pop'); setTimeout(function () { h.classList.remove('is-pop'); }, 1300); }, 420 + i * 220); });
  }

  // ---------- deslizar para eliminar (v4) ----------
  var SVG_BASURA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>';
  var ANCHO_DEL = 88, UMBRAL_SW = 30;
  var sw = { w: null, activo: false, decidido: false, horiz: false, x0: 0, y0: 0, dx: 0, base: 0, id: null }, swAbierto = null, arrastro = false;
  function swMov(w) { return w ? $('.ccd__mov', w) : null; }
  function swSet(w, x, anim) { var m = swMov(w); if (!m) return; m.classList.toggle('is-drag', !anim); m.style.transform = 'translateX(' + x + 'px)'; }
  function swCerrar(w) { if (!w) return; w.classList.remove('is-open'); swSet(w, 0, true); if (swAbierto === w) swAbierto = null; }
  function swAbrir(w) { if (swAbierto && swAbierto !== w) swCerrar(swAbierto); w.classList.add('is-open'); swSet(w, -ANCHO_DEL, true); swAbierto = w; }
  function swInicio(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest('[data-ccd-del]')) return;
    var w = e.target.closest('.ccd__swipe');
    if (!w || !$('.ccd__del', w)) return;
    sw.w = w; sw.x0 = e.clientX; sw.y0 = e.clientY; sw.dx = 0; sw.base = w.classList.contains('is-open') ? -ANCHO_DEL : 0;
    sw.activo = true; sw.decidido = false; sw.horiz = false; sw.id = e.pointerId;
  }
  function swMueve(e) {
    if (!sw.activo || e.pointerId !== sw.id) return;
    var dx = e.clientX - sw.x0, dy = e.clientY - sw.y0;
    if (!sw.decidido) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      sw.decidido = true; sw.horiz = Math.abs(dx) > Math.abs(dy) * 1.2;
      if (!sw.horiz) { sw.activo = false; return; }                       // gesto vertical: que siga el scroll
      try { sw.w.setPointerCapture(sw.id); } catch (e2) {}
      sw.w.classList.add('is-drag'); arrastro = true;
      if (swAbierto && swAbierto !== sw.w) swCerrar(swAbierto);
    }
    if (!sw.horiz) return;
    if (e.cancelable) e.preventDefault();
    var x = sw.base + dx;
    if (x > 0) x = x * .2;                                                   // goma a la derecha
    if (x < -ANCHO_DEL) x = -ANCHO_DEL + (x + ANCHO_DEL) * .25;              // goma más allá del botón
    sw.dx = dx; swSet(sw.w, x, false);
  }
  function swFin(e) {
    if (!sw.activo || e.pointerId !== sw.id) return;
    var w = sw.w; sw.activo = false; w.classList.remove('is-drag');
    if (!sw.decidido) {   // toque sin arrastre: si estaba abierta, solo se cierra (sin disparar el control tocado)
      if (w.classList.contains('is-open')) { swCerrar(w); arrastro = true; setTimeout(function () { arrastro = false; }, 60); }
      return;
    }
    if (!sw.horiz) return;
    var x = sw.base + sw.dx;
    if (sw.base === 0 ? x < -UMBRAL_SW : x < -ANCHO_DEL + UMBRAL_SW) swAbrir(w); else swCerrar(w);
    setTimeout(function () { arrastro = false; }, 60);
  }
  function eliminarLinea(w) {
    var key = w.dataset.key;
    w.style.maxHeight = w.offsetHeight + 'px';
    requestAnimationFrame(function () { w.classList.add('is-removing'); });
    swAbierto = null;
    change(key, 0, w).then(function (c) { if (!c) { w.classList.remove('is-removing'); w.style.maxHeight = ''; swCerrar(w); } });
  }
  function pistaDeslizar() {
    var ya = false;
    try { ya = sessionStorage.getItem('centro_swipe_nudge') === '1'; } catch (e) {}
    if (ya) return;
    var w = $('.ccd__swipe .ccd__del') && $('.ccd__swipe .ccd__del').closest('.ccd__swipe');
    if (!w) return;
    try { sessionStorage.setItem('centro_swipe_nudge', '1'); } catch (e) {}
    setTimeout(function () { w.classList.add('is-nudge'); setTimeout(function () { w.classList.remove('is-nudge'); }, 1000); }, 520);
  }

  // ---------- render ----------
  function render(c) {
    if (!c || !c.items) return;
    cart = c;
    var items = c.items, count = 0;
    items.forEach(function (it) { count += it.quantity; });
    $('[data-ccd-count]').textContent = count;
    $$('a.cart > em, a[href$="/cart"] > em', document).forEach(function (em) { em.textContent = count; });

    // envío gratis
    var envio = $('[data-ccd-envio]'), txt = $('[data-ccd-envio-txt]'), bar = $('[data-ccd-envio-bar]');
    var ev = envioEstado(c), pr = promoEstado(c), pct;
    var avanceEnvio = ev.ok ? 1 : Math.min(.96, Math.max(HAY_UMBRAL ? c.total_price / UMBRAL : 0, ENVIO_MIN_PZAS ? (count / ENVIO_MIN_PZAS) : 0, ev.por2Faltan === 1 ? .5 : 0));
    if (pr) {   // dos logros: 🎁 al 50% · 🏆 al final
      var avancePromo = pr.ok ? 1 : Math.min(.92, pr.qty / (pr.qty + pr.faltan));
      pct = ev.ok ? 100 : (pr.ok ? 50 + avanceEnvio * 50 : Math.max(6, avancePromo * 50));
      pintarHito('promo', true, pr.ok, pr.ok ? pr.txt : pr.txt + ' · falta' + (pr.faltan > 1 ? 'n ' + pr.faltan + ' pzas' : ' 1 pza'));
    } else { pct = ev.ok ? 100 : (c.total_price > 0 ? Math.max(4, avanceEnvio * 100) : 0); pintarHito('promo', false, false, null); }
    if (ev.ok) {
      envio.classList.add('is-ok');
      txt.innerHTML = pr && pr.ok ? '🎁 Regalo + 🏆 envío gratis <b>desbloqueados</b>' : (pr ? '🏆 ¡Envío gratis listo! <span>· +1 pza = 🎁 gratis</span>' : '🏆 ¡Envío gratis desbloqueado!');
    } else if (c.total_price > 0) {
      envio.classList.remove('is-ok');
      txt.innerHTML = (pr && pr.ok ? '🎁 Listo · ' : '') + (HAY_UMBRAL
        ? 'Te faltan <b>' + mx(ev.faltan) + '</b> para envío gratis' + (ev.pzasFaltan === 1 ? ' <span>· o 1 pieza más</span>' : '')
        : (ev.por2Faltan === 1 ? 'Envío gratis con <b>1 pieza más</b> <span>· del mismo producto</span>'
           : (ev.pzasFaltan === 1 ? 'Envío gratis con <b>1 pieza más</b>' : 'Envío gratis con <b>' + ev.pzasFaltan + ' piezas más</b>')));
    } else { envio.classList.remove('is-ok'); txt.innerHTML = HAY_UMBRAL ? 'Envío gratis desde <b>' + mx(UMBRAL) + '</b>' + (ENVIO_MIN_PZAS ? ' <span>· o con ' + ENVIO_MIN_PZAS + ' piezas</span>' : '')
      : 'Envío gratis con <b>2 del mismo producto</b>' + (ENVIO_MIN_PZAS ? ' <span>· o ' + ENVIO_MIN_PZAS + ' piezas</span>' : ''); }
    bar.style.width = Math.round(pct) + '%';
    pintarHito('envio', true, ev.ok, null);

    // líneas
    var cont = $('[data-ccd-lines]'), html = '';
    items.forEach(function (it, i) {
      var regalo = esRegalo(it);
      var variante = it.variant_title && it.variant_title !== 'Default Title' && it.variant_title !== 'Regalo' ? it.variant_title : '';
      var descs = (it.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean);
      var precioHtml, imgUrl = imagenDe(it);
      if (regalo) {
        var normal = it.original_line_price > 0 ? it.original_line_price : (it.original_price || 0) * it.quantity;
        precioHtml = (normal ? '<s>' + mx(normal) + '</s>' : '') + '<b>$0</b><span class="ccd__desc">Gratis</span>';
      } else if (it.final_line_price < it.original_line_price) {
        precioHtml = '<s>' + mx(it.original_line_price) + '</s><b>' + mx(it.final_line_price) + '</b><span class="ccd__desc">Ahorras ' + mx(it.original_line_price - it.final_line_price) + '</span>';
      } else {
        precioHtml = '<b>' + mx(it.final_line_price) + '</b>' + (it.quantity > 1 ? '<s style="text-decoration:none">' + mx(it.final_price) + ' c/u</s>' : '');
      }
      html += '<div class="ccd__swipe" data-key="' + esc(it.key) + '" style="animation-delay:' + (i * 40) + 'ms"><div class="ccd__mov">' +
        '<div class="ccd__line' + (regalo ? ' ccd__line--regalo' : '') + '" data-key="' + esc(it.key) + '">' +
        '<div class="ccd__img">' + (imgUrl ? '<img src="' + esc(img(imgUrl, 160)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</div>' +
        '<div class="ccd__info">' +
          (regalo ? '<span class="ccd__tag">🎁 Regalo</span>' : (descs.length ? '<span class="ccd__tag ccd__tag--promo">' + esc(descs[0]) + '</span>' : '')) +
          '<p class="ccd__nombre"><a href="/products/' + esc(it.handle) + '" style="color:inherit;text-decoration:none">' + esc(nombreCorto(it)) + '</a></p>' +
          (variante ? '<span class="ccd__var">' + esc(variante) + '</span>' : '') +
          '<div class="ccd__ctrl">' +
            (regalo
              ? '<span class="ccd__regalo-fijo">' + it.quantity + ' × incluido en tu promo</span>'
              : '<div class="ccd__qty"><button type="button" data-ccd-menos aria-label="Quitar uno">−</button><output>' + it.quantity + '</output><button type="button" data-ccd-mas aria-label="Agregar uno">+</button></div>') +
            '<div class="ccd__precio">' + precioHtml + '</div>' +
          '</div>' +
          (regalo ? '' : '<button type="button" class="ccd__quitar" data-ccd-quitar>Quitar</button>') +
        '</div></div>' +
        (regalo ? '' : '<button type="button" class="ccd__del" data-ccd-del aria-label="Eliminar del carrito">' + SVG_BASURA + '<span>Eliminar</span></button>') +
        '</div></div>';
    });
    swAbierto = null;
    cont.innerHTML = html;
    $('[data-ccd-vacio]').hidden = items.length > 0;

    // totales
    var ahorro = c.total_discount || 0;
    $('[data-ccd-subtotal]').textContent = mx(c.total_price);
    $('[data-ccd-pagar-total]').textContent = mx(c.total_price);
    var pagar = $('[data-ccd-pagar]');
    pagar.setAttribute('href', urlPago(c));
    sincronizarCodigo(c);
    pagar.classList.toggle('is-off', items.length === 0);
    pagar.setAttribute('aria-disabled', items.length === 0 ? 'true' : 'false');
    var nota = $('[data-ccd-nota]');
    if (nota) nota.innerHTML = ev.ok ? '<b>Envío GRATIS</b> incluido · impuestos incluidos.' : 'Envío e impuestos se calculan al pagar.';
    pintarAhorro(ahorro);
    ahorroCompare(items, ahorro);
    sugerencias(items);
  }
  function pintarAhorro(total) {
    var row = $('[data-ccd-ahorro-row]');
    row.hidden = !(total > 0);
    $('[data-ccd-ahorro]').textContent = mx(total);
  }
  // suma el ahorro vs precio de lista (compare_at) usando /products/<handle>.js (cache)
  function ahorroCompare(items, base) {
    var c0 = cart;
    Promise.all(items.map(function (it) {
      if (esRegalo(it)) return 0;
      return producto(it.handle).then(function (p) {
        if (!p) return 0;
        var v = (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
        if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return 0;
        return (v.compare_at_price - v.price) * it.quantity;
      });
    })).then(function (arr) {
      if (cart !== c0) return;
      var extra = arr.reduce(function (a, b) { return a + b; }, 0);
      pintarAhorro(base + extra);
    });
  }

  // ---------- sugeridos ----------
  var sugToken = 0;
  function sugerencias(items) {
    var enCarrito = {}, cats = [];
    items.forEach(function (it) {
      enCarrito[it.product_id] = true;
      var c = catDe(it); if (c && cats.indexOf(c) < 0) cats.push(c);
    });
    var ids = [];
    cats.forEach(function (c) { (CAT[c] || []).forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); }); });
    DEFAULT_SUG.concat(CAT.barba, CAT.capilar, CAT.rostro, CAT.corporal).forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); });
    ids = ids.filter(function (id) { return !enCarrito[id] && PROD[id] && !PROD[id].noSug; }).slice(0, MAX_SUG + 2);
    var tok = ++sugToken, sec = $('[data-ccd-sug]'), grid = $('[data-ccd-sug-grid]');
    if (!abierto && !grid.innerHTML) return;   // no gastar peticiones si el cajón nunca se ha abierto
    Promise.all(ids.map(function (id) { return producto(PROD[id].h); })).then(function (prods) {
      if (tok !== sugToken) return;
      var html = '', n = 0;
      prods.forEach(function (p, i) {
        if (!p || !p.available || n >= MAX_SUG) return;
        var v = (p.variants || []).filter(function (x) { return x.available && x.price > 0 && x.title !== 'Regalo'; })[0];
        if (!v) return;
        var imgUrl = (v.featured_image && v.featured_image.src) || (p.images && p.images[0]) || (p.featured_image) || '';
        html += '<div class="ccd__card" data-variant="' + v.id + '" style="animation-delay:' + (n * 50) + 'ms">' +
          '<img src="' + esc(img(imgUrl, 140)) + '" alt="' + esc(p.title) + '" loading="lazy">' +
          '<div class="ccd__card-info"><b>' + esc(PROD[ids[i]].n) + '</b><span><em>' + mx(v.price) + '</em>' + (v.compare_at_price > v.price ? '<s>' + mx(v.compare_at_price) + '</s>' : '') + '</span></div>' +
          '<button type="button" class="ccd__add" data-ccd-add="' + v.id + '">+ AGREGAR</button></div>';
        n++;
      });
      grid.innerHTML = html;
      sec.hidden = n === 0;
    });
  }

  // ---------- timer ----------
  function timerFin() {
    var fin = 0;
    try { fin = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10); } catch (e) {}
    if (!fin || fin - Date.now() <= 0) { fin = Date.now() + TIMER_MIN * 60000; try { sessionStorage.setItem(TIMER_KEY, String(fin)); } catch (e) {} }
    return fin;
  }
  function tick() {
    var rest = timerFin() - Date.now();
    if (rest <= 0) rest = timerFin() - Date.now();
    var s = Math.max(0, Math.floor(rest / 1000)), m = Math.floor(s / 60);
    $('[data-ccd-timer-num]').textContent = (m < 10 ? '0' : '') + m + ':' + ((s % 60) < 10 ? '0' : '') + (s % 60);
  }

  // ---------- abrir / cerrar ----------
  function open(sinRefresh) {
    var primera = !abierto;
    if (!abierto) {
      abierto = true; ultimoFoco = document.activeElement;
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ccd-lock');
      document.body.classList.remove('overflow-hidden');   // por si el drawer nativo alcanzó a marcar el body
      tick(); clearInterval(timerId); timerId = setInterval(tick, 1000);
      setTimeout(function () { var b = $('.ccd__close'); if (b) b.focus({ preventScroll: true }); }, 380);
      if (cart && !$('[data-ccd-sug-grid]').innerHTML) sugerencias(cart.items);
      celebrar();
      pistaDeslizar();
    }
    if (sinRefresh === true || (primera && cart && CC())) return Promise.resolve(cart);   // ya tenemos estado fresco: sin petición extra
    return refresh().then(null, function () { return cart; });
  }
  function close() {
    if (!abierto) return;
    abierto = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ccd-lock');
    clearInterval(timerId); timerId = null;
    if (ultimoFoco && ultimoFoco.focus) try { ultimoFoco.focus({ preventScroll: true }); } catch (e) {}
  }
  var toastId = null;
  function toast(msg, conReintento) {
    var t = $('.ccd__toast');
    if (!t) { t = document.createElement('div'); t.className = 'ccd__toast'; $('.ccd__foot').appendChild(t); }
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (conReintento ? '<button type="button" data-ccd-reintentar>Reintentar</button>' : '');
    t.classList.add('is-on');
    clearTimeout(toastId); toastId = setTimeout(function () { t.classList.remove('is-on'); }, conReintento ? 7000 : 3200);
  }

  // ---------- eventos del cajón ----------
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ccd-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('[data-ccd-reintentar]')) { e.preventDefault(); refresh().then(function () { toast('Carrito actualizado'); }, function (err) { toast(mensaje(err), true); }); return; }
    if (t.closest('[data-ccd-pagar]')) return;   // sigue a /checkout
    var del = t.closest('[data-ccd-del]');
    if (del) { e.preventDefault(); var wDel = del.closest('.ccd__swipe'); if (wDel) eliminarLinea(wDel); return; }
    var line = t.closest('.ccd__line');
    if (line) {
      var key = line.dataset.key, it = (cart && cart.items || []).filter(function (x) { return x.key === key; })[0];
      if (!it) return;
      if (t.closest('[data-ccd-mas]')) { change(key, it.quantity + 1, line); return; }
      if (t.closest('[data-ccd-menos]')) { change(key, it.quantity - 1, line); return; }
      if (t.closest('[data-ccd-quitar]')) { change(key, 0, line); return; }
    }
    var addBtn = t.closest('[data-ccd-add]');
    if (addBtn) { add(parseInt(addBtn.dataset.ccdAdd, 10), 1, addBtn.closest('.ccd__card')); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) close(); });
  (function () {
    var cont = $('[data-ccd-lines]');
    if (!cont || !window.PointerEvent) return;
    cont.addEventListener('pointerdown', swInicio);
    cont.addEventListener('pointermove', swMueve);
    cont.addEventListener('pointerup', swFin);
    cont.addEventListener('pointercancel', swFin);
    cont.addEventListener('click', function (e) { if (arrastro) { e.preventDefault(); e.stopPropagation(); } }, true);   // clic fantasma tras arrastrar
    root.addEventListener('pointerdown', function (e) { if (swAbierto && !e.target.closest('.ccd__swipe')) swCerrar(swAbierto); });
  })();

  // Página /cart (formulario Shrine): el botón 'Pagar' también pasa por el código cuando toca (2026-09-19)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'cart' || (e.submitter && e.submitter.name && e.submitter.name !== 'checkout')) return;
    var u = urlPago(cart);
    if (u === '/checkout') return;
    e.preventDefault(); location.href = u;
  }, true);

  // ---------- integración con centro-cart.js ----------
  document.addEventListener('centro:cart:updated', function (e) { if (emitiendo) return; if (e.detail && e.detail.items) render(e.detail); });
  document.addEventListener('centro:cart:open', function (e) { open(!!(e.detail && e.detail.fresh)); });
  document.addEventListener('centro:cart:error', function (e) {
    limpiarBusy();
    var d = e.detail || {};
    if (abierto || /change|refresh|inicio/.test(d.contexto || '')) toast(d.mensaje || 'No pudimos actualizar tu carrito. Intenta de nuevo.', true);
    else { open(true); toast(d.mensaje || 'No pudimos actualizar tu carrito. Intenta de nuevo.', true); }
  });

  // ---------- interceptar iconos del carrito ----------
  function esLinkCarrito(a) {
    if (!a || !a.getAttribute) return false;
    var href = a.getAttribute('href') || '';
    if (a.id === 'cart-icon-bubble' || a.classList.contains('cart') && /\/cart\/?$/.test(href)) return true;
    try { var u = new URL(href, location.href); return u.origin === location.origin && /^\/cart\/?$/.test(u.pathname) && !a.closest('#centro-cd'); } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a || !esLinkCarrito(a)) return;
    if (a.closest('.ccd__pagar')) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  // Parche a Shrine: su CartDrawer.open() (icono del header) abre este cajón; el add-to-cart lo toma centro-cart.js
  function parchar() {
    if (!window.customElements) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || !C.prototype || C.prototype.__centro) return;
      C.prototype.__centro = true;
      C.prototype.open = function () { open(); };
      var cerrar = C.prototype.close;
      C.prototype.close = function () { try { cerrar && cerrar.apply(this, arguments); } catch (e) {} document.body.classList.remove('overflow-hidden'); };
    }).catch(function () {});
    customElements.whenDefined('cart-notification').then(function () {
      var N = customElements.get('cart-notification');
      if (N && N.prototype && !N.prototype.__centro) { N.prototype.__centro = true; N.prototype.open = function () { open(); }; }
    }).catch(function () {});
  }
  parchar();

  // ---------- CentroCart de respaldo (solo si assets/centro-cart.js no cargó) ----------
  function respaldoCentroCart() {
    if (window.CentroCart) return;
    window.CentroCart = {
      _fallback: true,
      add: function (lines, opts) {
        var items = (Array.isArray(lines) ? lines : [lines]).map(function (l) { return { id: l.id || l.variant_id, quantity: l.quantity || 1, properties: l.properties }; });
        return j('/cart/add.js', { items: items }).then(function () { return j('/cart.js'); })
          .then(function (c) { render(c); emitir(c); if (!opts || opts.open !== false) open(true); return c; })
          .catch(function (e) { toast(mensaje(e), true); throw e; });
      },
      setBundle: function (spec) { return window.CentroCart.add(spec && spec.lines || spec, { open: true }); },
      refresh: refresh, open: open, close: close, ultimo: function () { return cart; }
    };
  }
  function inicial() {
    var el = document.getElementById('centro-cart-inicial');
    if (!el) return null;
    try { var c = JSON.parse(el.textContent || ''); return c && c.items ? c : null; } catch (e) { return null; }
  }

  // ---------- init ----------
  api.open = open; api.close = close; api.refresh = refresh; api.render = render; api.add = add; api.change = change; api.toast = toast;
  window.CentroCartDrawer = api;
  tick();
  function init() {
    respaldoCentroCart();
    var m = CC();
    var c0 = (m && m.ultimo && m.ultimo()) || inicial();
    if (c0) render(c0); else if (!m) refresh().then(null, function () {});   // con motor: él emite el estado; sin motor y sin JSON: una lectura
    if (/[#?&](carrito|abrir_carrito)/.test(location.hash + location.search)) open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
